export default "__VITE_ASSET__091931e4__"